export default __webpack_public_path__ + "images/9e39f510bc790e6ba99112bf1237c25f.svg";